import { ChangeDetectionStrategy, Component } from '@angular/core';
import { baseModulesRoutes } from '@app/config';
import { icon } from '@components/icon/icon.interface';

@Component({
  selector: 'app-modules-menu',
  templateUrl: './modules-menu.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ModulesMenuComponent {
  items: { icon: icon; label: string; permission: string; route: string }[] = [
    {
      icon: 'settings',
      label: $localize`Administracja`,
      permission: 'KonfiguracjaUczelni',
      route: baseModulesRoutes.administration,
    },
    {
      icon: 'kolumny',
      label: $localize`Studia`,
      permission: 'Studia',
      route: baseModulesRoutes.studies,
    },
    {
      icon: 'graduation-cap',
      label: $localize`Dyplomowanie`,
      permission: 'Dyplomowanie',
      route: baseModulesRoutes.dissertation,
    },
    {
      icon: 'briefcase',
      label: $localize`Praktyki`,
      permission: 'Praktyki',
      route: baseModulesRoutes.practices,
    },
    {
      icon: 'file-alt',
      label: $localize`Wnioski`,
      permission: 'Wnioski',
      route: baseModulesRoutes.requests,
    },
    {
      icon: 'przypisz-wplate',
      label: $localize`Stypendia`,
      permission: 'Stypendia',
      route: baseModulesRoutes.scholarships,
    },
    {
      icon: 'korekta',
      label: $localize`Finanse`,
      permission: 'Finanse',
      route: baseModulesRoutes.finances,
    },
    {
      icon: 'nalicz-oplate',
      label: $localize`Biuro karier`,
      permission: 'BiuroKarier',
      route: baseModulesRoutes.careerOffice,
    },
    {
      icon: 'user',
      label: $localize`Akademiki`,
      permission: 'Akademiki',
      route: baseModulesRoutes.dormitories,
    },
    {
      icon: 'user-edit',
      label: $localize`Rekrutacja`,
      permission: 'Rekrutacja',
      route: baseModulesRoutes.recruitment,
    },
    {
      icon: 'question',
      label: $localize`Ankiety`,
      permission: 'Ankiety',
      route: baseModulesRoutes.questionnaires,
    },
    {
      icon: 'file-download',
      label: $localize`Repozytorium plików`,
      permission: 'RepozytoriumPlikow',
      route: baseModulesRoutes.filesRepository,
    },
    {
      icon: 'file-download',
      label: $localize`Moje dane`,
      permission: 'Studia.PlatformaStudenta.Osoby',
      route: baseModulesRoutes.mojeDane,
    },
  ];
  baseModulesRoutes = baseModulesRoutes;
}
